var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":require("@/assets/video/amh.mp4"),"type":"video/mp4"}})])])
}]

export { render, staticRenderFns }